export interface CaseStudy {
  id: string;
  title: string;
  location: string;
  propertyType: string;
  challenge: string;
  outcome: string;
  metric?: string;
}

export const landlordCaseStudies: CaseStudy[] = [
  {
    id: "mayfair-apartment",
    title: "Vacant Mayfair apartment let within 12 days",
    location: "Mayfair, W1K",
    propertyType: "2-bedroom luxury apartment",
    challenge:
      "A landlord returning from overseas needed a reliable tenant quickly without compromising on vetting standards.",
    outcome:
      "We staged the property, launched targeted marketing, and placed a pre-qualified professional tenant on a 24-month AST with rent collected from day one.",
    metric: "12 days to let · 100% asking rent achieved",
  },
  {
    id: "chelsea-portfolio",
    title: "Portfolio yield uplift across three Chelsea units",
    location: "Chelsea, SW3",
    propertyType: "3-unit residential portfolio",
    challenge:
      "Three properties were under-rented with inconsistent tenancy lengths and reactive maintenance.",
    outcome:
      "We restructured leases, introduced proactive maintenance schedules, and increased combined portfolio income while reducing void periods.",
    metric: "8% yield improvement · Zero voids in 18 months",
  },
  {
    id: "shoreditch-conversion",
    title: "New-build conversion managed from handover",
    location: "Shoreditch, E1",
    propertyType: "1-bedroom new-build",
    challenge:
      "A first-time landlord needed end-to-end support from developer handover through first tenancy and compliance setup.",
    outcome:
      "We coordinated snagging, inventory, licensing checks, and tenant placement — delivering a fully compliant, income-generating asset from day one.",
    metric: "Fully let within 3 weeks of completion",
  },
];
